var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 31.9991C12.0299 32.0013 10.1284 31.2765 8.65964 29.9637C7.19087 28.6509 6.25813 26.8423 6.04012 24.8844C5.82212 22.9265 6.33416 20.9571 7.47817 19.3533C8.62218 17.7495 10.3177 16.6243 12.2399 16.1931C11.6837 13.5993 12.1808 10.8907 13.6216 8.66338C15.0624 6.43601 17.3291 4.87224 19.9229 4.31608C22.5167 3.75992 25.2252 4.25693 27.4526 5.69777C29.68 7.13861 31.2437 9.40526 31.7999 11.9991H31.9999C34.4798 11.9966 36.8722 12.9156 38.7126 14.5778C40.553 16.24 41.7101 18.5267 41.9593 20.9941C42.2086 23.4614 41.5321 25.9334 40.0613 27.93C38.5905 29.9267 36.4302 31.3056 33.9999 31.7991M29.9999 25.9991L23.9999 19.9991M23.9999 19.9991L17.9999 25.9991M23.9999 19.9991V43.9991",
    stroke: "#1462B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloudUpload);
export default __webpack_public_path__ + "static/media/ic_cloud_upload.5818ecc747e1f55290147edd4caaf270.svg";
export { ForwardRef as ReactComponent };